<template>
    <div>
        <v-flex
                row wrap align-top justify-center>
            <Table :elements="startups"
                  :titleHeader="header"
                  :addNewTitle="addNewStartupTitle"
                  :showButton="showButton"
                  :searchCallback="searchStartups"
                  :clickCallback="navigate"
                  :searchStartup="searchStartups"></Table>
        </v-flex>

    </div>


</template>

<script>
    import RouterService from "@/helpers/RouterService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import Table from "@/components/Tables/Table";
    import ExcelJS from 'exceljs';
    import FileSaver from 'file-saver';

    export default {
        name: "SynonymsTable",
        components: {Table},
        data() {
            return {
                showButton: true,
                header: "Synonyms",
                addNewStartupTitle: "Search Startup",
                startups: [],
                completeStartups: [],
            }
        },
        methods: {
            navigate(startup) {
                let path = {
                    name: "StartupInfo",
                    params: {
                        //approved: this.approved,
                        startupId: startup.id
                        //startupName: startup.nameToShow,
                    },
                };
                RouterService.goTo(path);
            },
            searchStartups(search_query) {
                let requestUrl = {
                    url: UrlsService.searchStartup,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text:search_query,
                        elasticSearchRequest:{
                            analyzer:"synonym_analyzer",
                            query: "TEXTUAL",
                            pageSize: 10,
                            pageNumber: 0
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "List Searched Startups",
                    loading: "Waiting for list of startups...",
                    error: "Cannot get startups...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.startups = [];
                        this.completeStartups = [];
                        let responseSearch = responseSuccess.response.searchResults;
                        this.completeStartups = responseSearch;
                        console.log(responseSearch)
                        for (let i = 0; i < responseSearch.length; i++) {
                            this.startups.push({
                                id: responseSearch[i]["id"],
                                nameToShow: responseSearch[i].name,
                                email: responseSearch[i]["ContactDetails"],
                            });
                            if (i !== responseSearch.length - 1) {
                                this.startups.push({divider: true, inset: false,});
                            }
                        }
                    });
    }
        }
    }
</script>

<style scoped>

</style>